import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, map, Observable } from 'rxjs';

import { QualityCheckListTemplate } from '@shared/models';

import { BaseService } from '../base.service';
import { LoadersService } from '../loaders.service';

@Injectable({
  providedIn: 'root',
})
export class QualityCheckListTemplateService extends BaseService {
  constructor(
    private http: HttpClient,
    private loadersService: LoadersService
  ) {
    super();
  }

  getAll(loader: string): Observable<QualityCheckListTemplate[]> {
    this.loadersService.show(loader);
    return this.http
      .get<QualityCheckListTemplate[]>(`${this.baseUrl}/quality-check-list-templates`)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  add(loader: string, dto: QualityCheckListTemplate): Observable<QualityCheckListTemplate> {
    this.loadersService.show(loader);
    return this.http
      .post<QualityCheckListTemplate>(`${this.baseUrl}/quality-check-list-templates`, dto)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  edit(loader: string, dto: QualityCheckListTemplate): Observable<QualityCheckListTemplate> {
    this.loadersService.show(loader);
    return this.http
      .put<QualityCheckListTemplate>(`${this.baseUrl}/quality-check-list-templates`, dto)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  delete(loader: string, id: string): Observable<boolean> {
    this.loadersService.show(loader);
    return this.http.delete(`${this.baseUrl}/quality-check-list-templates/${id}`, { observe: 'response' }).pipe(
      map((response) => this.isStatusSucceed(response.status)),
      finalize(() => this.loadersService.hide(loader))
    );
  }
}
